module.exports = __webpack_public_path__ + "static/media/chair.6704354f.png";